<template>
  <div class="w-full max-w-screen-xl mx-auto mb-10 overflow-hidden" :class="noHorizontalPadding ? 'px-0' : 'px-6'">
    <Carousel class="w-full relative" :opts="{ loop: true }">
      <CarouselContent class="-ml-0">
        <CarouselItem
          v-for="store in featuredShops"
          :key="store?.id"
          class="basis-full"
        >
          <FeaturedStoreCard
            :id="store?.id"
            :name="store?.name"
            :logo="store?.logo"
            :availability="store?.availability"
            :createdAt="store?.createdAt"
            :loading="loading"
            :domain="store?.domain"
          />
        </CarouselItem>
      </CarouselContent>

      <template v-if="featuredShops.length > 1">
        <CarouselPrevious
          variant="ghost"
          class="top-auto bottom-6 left-6 translate-y-0 text-white hover:bg-transparent hover:text-white"
        >
          <ChevronLeft class="size-[18px]" />
        </CarouselPrevious>

        <CarouselDotButtons
          class="absolute bottom-6 left-1/2 -translate-x-1/2"
          selected-class="border-[#d9d9d9]"
        />

        <CarouselNext
          variant="ghost"
          class="top-auto bottom-6 right-6 translate-y-0 text-white hover:bg-transparent hover:text-white"
        >
          <ChevronRight class="size-[18px]" />
        </CarouselNext>
      </template>
    </Carousel>
  </div>
</template>

<script setup lang="ts">
import FeaturedStoreCard from '@/components/FeaturedStoreCard.vue';
import { Carousel, CarouselContent, CarouselDotButtons, CarouselItem } from '@/components/ui/carousel';
import CarouselNext from '@/components/ui/carousel/CarouselNext.vue';
import CarouselPrevious from '@/components/ui/carousel/CarouselPrevious.vue';
import { useShopsStore } from '@/stores/shop';
import { ChevronLeft, ChevronRight } from 'lucide-vue-next';
import { storeToRefs } from 'pinia';

defineProps<{
  noHorizontalPadding?: boolean;
}>();

const shopsStore = useShopsStore();
const { featuredShops, loading } = storeToRefs(shopsStore);
</script>
